export const supportedCurrencies = {
  USD: {
    symbol: '$',
    name: 'US Dollar',
    code: 'USD',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  EUR: {
    symbol: '€',
    name: 'Euro',
    code: 'EUR',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'after',
  },
  GBP: {
    symbol: '£',
    name: 'British Pound',
    code: 'GBP',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  JPY: {
    symbol: '¥',
    name: 'Japanese Yen',
    code: 'JPY',
    decimalPlaces: 0,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  BRL: {
    symbol: 'R$',
    name: 'Brazilian Real',
    code: 'BRL',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  INR: {
    symbol: '₹',
    name: 'Indian Rupee',
    code: 'INR',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  AUD: {
    symbol: '$',
    name: 'Australian Dollar',
    code: 'AUD',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  CAD: {
    symbol: '$',
    name: 'Canadian Dollar',
    code: 'CAD',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  ARS: {
    symbol: '$',
    name: 'Argentine Peso',
    code: 'ARS',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  CLP: {
    symbol: '$',
    name: 'Chilean Peso',
    code: 'CLP',
    decimalPlaces: 0,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  COP: {
    symbol: '$',
    name: 'Colombian Peso',
    code: 'COP',
    decimalPlaces: 0,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  PEN: {
    symbol: 'S/.',
    name: 'Peruvian Sol',
    code: 'PEN',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  UYU: {
    symbol: '$U',
    name: 'Uruguayan Peso',
    code: 'UYU',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  VES: {
    symbol: 'Bs.S.',
    name: 'Venezuelan Bolívar',
    code: 'VES',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  BOB: {
    symbol: 'Bs.',
    name: 'Bolivian Boliviano',
    code: 'BOB',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  PYG: {
    symbol: '₲',
    name: 'Paraguayan Guarani',
    code: 'PYG',
    decimalPlaces: 0,
    thousandSeparator: '.',
    decimalSeparator: ',',
    symbolPosition: 'before',
  },
  MXN: {
    symbol: '$',
    name: 'Mexican Peso',
    code: 'MXN',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
  CNY: {
    symbol: '¥',
    name: 'Chinese Yuan',
    code: 'CNY',
    decimalPlaces: 2,
    thousandSeparator: ',',
    decimalSeparator: '.',
    symbolPosition: 'before',
  },
};

// País (código ISO-3166 alpha-2) -> moneda local. Se usa para poner la
// moneda del cliente como default en vez de asumir siempre USD.
const COUNTRY_TO_CURRENCY = {
  PE: 'PEN', US: 'USD', MX: 'MXN', GB: 'GBP', UK: 'GBP',
  ES: 'EUR', FR: 'EUR', DE: 'EUR', IT: 'EUR', PT: 'EUR', NL: 'EUR', IE: 'EUR',
  BR: 'BRL', AR: 'ARS', CL: 'CLP', CO: 'COP', VE: 'VES', BO: 'BOB', PY: 'PYG', UY: 'UYU',
  CA: 'CAD', AU: 'AUD', JP: 'JPY', IN: 'INR', CN: 'CNY',
};

// El perfil guarda el país como texto libre (lo que escribió el usuario en
// el onboarding), no como código ISO — se normaliza lo más común acá.
const COUNTRY_NAME_TO_ISO = {
  peru: 'PE', 'perú': 'PE',
  'united states': 'US', usa: 'US', 'estados unidos': 'US',
  mexico: 'MX', 'méxico': 'MX',
  colombia: 'CO', argentina: 'AR', chile: 'CL',
  brazil: 'BR', brasil: 'BR',
  venezuela: 'VE', bolivia: 'BO', paraguay: 'PY', uruguay: 'UY',
  spain: 'ES', 'españa': 'ES', france: 'FR', francia: 'FR',
  germany: 'DE', alemania: 'DE', italy: 'IT', italia: 'IT',
  'united kingdom': 'GB', uk: 'GB', 'reino unido': 'GB',
  canada: 'CA', 'canadá': 'CA', australia: 'AU',
  japan: 'JP', 'japón': 'JP', india: 'IN', china: 'CN',
};

// Timezone del navegador -> país. Fallback cuando no hay país guardado en
// el perfil (p.ej. usuario que aún no completó "Perfil" en Configuración).
const TIMEZONE_TO_COUNTRY = {
  'America/Lima': 'PE',
  'America/Bogota': 'CO',
  'America/Argentina/Buenos_Aires': 'AR',
  'America/Santiago': 'CL',
  'America/Sao_Paulo': 'BR',
  'America/Mexico_City': 'MX',
  'America/Caracas': 'VE',
  'America/La_Paz': 'BO',
  'America/Asuncion': 'PY',
  'America/Montevideo': 'UY',
  'America/New_York': 'US',
  'America/Chicago': 'US',
  'America/Denver': 'US',
  'America/Los_Angeles': 'US',
  'Europe/Madrid': 'ES',
  'Europe/London': 'GB',
  'Europe/Paris': 'FR',
  'Europe/Berlin': 'DE',
  'Europe/Rome': 'IT',
  'Asia/Tokyo': 'JP',
  'Asia/Shanghai': 'CN',
  'Asia/Kolkata': 'IN',
  'Australia/Sydney': 'AU',
};

// Detecta la moneda local del cliente: 1) por el país guardado en su
// perfil si es reconocible, 2) si no, por el idioma/región del navegador,
// 3) si no, por la zona horaria, 4) si nada aplica, USD.
export const detectDefaultCurrency = (userCountry) => {
  if (userCountry) {
    const iso = COUNTRY_NAME_TO_ISO[String(userCountry).trim().toLowerCase()];
    if (iso && COUNTRY_TO_CURRENCY[iso]) return COUNTRY_TO_CURRENCY[iso];
  }
  try {
    const locale = (typeof navigator !== 'undefined' && navigator.language) || '';
    const region = locale.split('-')[1]?.toUpperCase();
    if (region && COUNTRY_TO_CURRENCY[region]) return COUNTRY_TO_CURRENCY[region];
  } catch (e) {
    // ignorar, seguir con el siguiente método
  }
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    const iso = TIMEZONE_TO_COUNTRY[tz];
    if (iso && COUNTRY_TO_CURRENCY[iso]) return COUNTRY_TO_CURRENCY[iso];
  } catch (e) {
    // ignorar, cae al default
  }
  return 'USD';
};

// Moneda secundaria sugerida: USD para todos, salvo que la moneda local
// YA sea USD (p.ej. cliente en EEUU), en cuyo caso la secundaria es EUR —
// tal como se pidió explícitamente.
export const getSecondaryCurrency = (primaryCurrency) => (primaryCurrency === 'USD' ? 'EUR' : 'USD');

export const formatCurrency = (amount, currencyCode = 'USD') => {
  const currency = supportedCurrencies[currencyCode] || supportedCurrencies.USD;
  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: currency.decimalPlaces,
    maximumFractionDigits: currency.decimalPlaces,
    useGrouping: true,
  }).format(amount);

  if (currency.symbolPosition === 'before') {
    return `${currency.symbol}${formattedNumber}`;
  }
  return `${formattedNumber}${currency.symbol}`;
};

export const parseCurrency = (input, currencyCode = 'USD') => {
  const currency = supportedCurrencies[currencyCode] || supportedCurrencies.USD;
  const cleanInput = input
    .replace(new RegExp(`[${currency.symbol}${currency.thousandSeparator}]`, 'g'), '')
    .replace(currency.decimalSeparator, '.');
  return parseFloat(cleanInput);
};

export const convertCurrency = async (amount, fromCurrency, toCurrency) => {
  // TODO: Implement actual currency conversion using an API
  // For now, return the same amount
  return amount;
};

export const getCurrencySymbol = (currencyCode = 'USD') => {
  return supportedCurrencies[currencyCode]?.symbol || supportedCurrencies.USD.symbol;
};

export const getCurrencyName = (currencyCode = 'USD') => {
  return supportedCurrencies[currencyCode]?.name || supportedCurrencies.USD.name;
};

// 21 sep 2026 (Augusto: "siempre colocar USD y la moneda local de donde
// es el usuario PRIMERO. Luego EUR y el resto de monedas").
//
// La lista salía en el orden en que está escrita en el objeto, con el
// sol peruano en el puesto 13 de una lista de treinta y pico. Alguien en
// Lima usa dos monedas todo el día y tenía que bajar cada vez.
//
// Orden: la moneda local del usuario, USD, EUR, y el resto alfabético.
// Si la local ES el dólar, no se repite. El resto va alfabético porque
// cualquier otro orden "de importancia" es una opinión nuestra sobre la
// plata de otro.
export const getCurrencyOptions = (monedaLocal) => {
  const local = (monedaLocal || '').toUpperCase();
  const prioridad = [];
  if (local && supportedCurrencies[local]) prioridad.push(local);
  ['USD', 'EUR'].forEach((c) => { if (!prioridad.includes(c)) prioridad.push(c); });

  const opcion = (code) => ({
    value: code,
    label: `${supportedCurrencies[code].name} (${supportedCurrencies[code].symbol})`,
  });
  const resto = Object.keys(supportedCurrencies)
    .filter((code) => !prioridad.includes(code))
    .sort((a, b) => supportedCurrencies[a].name.localeCompare(supportedCurrencies[b].name));

  return [...prioridad.filter((c) => supportedCurrencies[c]).map(opcion), ...resto.map(opcion)];
};
